// Static services data - hardcoded for performance
// Source: docs/about-smallbiz-innovation/services-content/services.md in the archived smallbiz-innovation repo (no copy here).

export interface Service {
  id: number;
  slug: string;
  name: string;
  tagline: string;
  icon: string;
  status: 'active' | 'coming_soon' | 'paused';
  featured: boolean;
  excerpt: string;
  description?: string;
}

export const SERVICES: Service[] = [
  {
    id: 1,
    slug: 'marketing',
    name: 'Marketing',
    tagline: 'Get found. Get chosen. Grow your reach.',
    icon: 'Rocket',
    status: 'active',
    featured: true,
    excerpt:
      'Marketing that moves the needle. We help you clarify positioning, build effective campaigns, and connect with your ideal customers. No fluff, just results.',
  },
  {
    id: 2,
    slug: 'sales',
    name: 'Sales',
    tagline: 'Convert more leads into customers.',
    icon: 'TrendingUp',
    status: 'active',
    featured: true,
    excerpt:
      'Struggling to close deals? We design better sales processes, build smarter pipelines, and create collateral that actually helps your team sell. Stop guessing, start converting.',
  },
  {
    id: 3,
    slug: 'strategy',
    name: 'Strategy',
    tagline: 'Build a strategy you can actually execute.',
    icon: 'Target',
    status: 'active',
    featured: true,
    excerpt:
      'Tired of vague advice? Get a strategy that actually works for your business. We help you define direction, identify opportunities, and build executable roadmaps that move the business forward.',
  },
  {
    id: 4,
    slug: 'finance',
    name: 'Finance',
    tagline: 'Know your numbers. Make smarter decisions.',
    icon: 'DollarSign',
    status: 'active',
    featured: true,
    excerpt:
      'Your financials should tell a story, not confuse you. We help you understand cash flow, clean up messy books, and build systems that give you confidence in every financial decision.',
  },
  {
    id: 5,
    slug: 'operations',
    name: 'Operations',
    tagline: 'Clear processes. Scale without chaos.',
    icon: 'Settings',
    status: 'active',
    featured: true,
    excerpt:
      'Operations falling apart as you grow? We design efficient workflows, build SOPs, and create systems that scale with you, not against you.',
  },
  {
    id: 6,
    slug: 'automation',
    name: 'Automation',
    tagline: 'Use the right tools. Build better systems.',
    icon: 'Zap',
    status: 'active',
    featured: true,
    excerpt:
      'Tech should make work easier, not harder. We identify automation opportunities, configure the right tools, and integrate systems so they actually work together.',
  },
  {
    id: 7,
    slug: 'leadership',
    name: 'Leadership',
    tagline: 'Lead with clarity. Execute with confidence.',
    icon: 'Crown',
    status: 'active',
    featured: true,
    excerpt:
      'Running a business is hard. You need a strategic partner who gets it. We provide executive-level support, help you navigate challenges, and build the clarity you need to lead with confidence.',
  },
];

// Helper functions
export function getFeaturedServices(): Service[] {
  return SERVICES.filter((service) => service.featured && service.status === 'active');
}

export function getActiveServices(): Service[] {
  return SERVICES.filter((service) => service.status === 'active');
}

export function getServiceBySlug(slug: string): Service | undefined {
  return SERVICES.find((service) => service.slug === slug);
}
